import script from "./trainingAdmission.vue?vue&type=script&setup=true&lang=js"
export * from "./trainingAdmission.vue?vue&type=script&setup=true&lang=js"

import "./trainingAdmission.vue?vue&type=style&index=0&id=079bf660&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-079bf660"]])

export default __exports__